'use client';

import React, { useEffect } from 'react';

export default function ReviewsWidget() {
  useEffect(() => {
    // Load Elfsight platform script
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="my-8">
      {/* Elfsight Google Reviews Widget */}
      <div 
        className="elfsight-app-79df4bf8-0f60-41fd-9f06-bf34c80d7a89" 
        data-elfsight-app-lazy
      />
    </div>
  );
}